import React from 'react';
import { FileItemLayout } from '../ui';
import FileItem from './FileItem';

const { FileListWrapper } = FileItemLayout;

const FileList = ({
  disabled,
  viewOnly,
  onlyUploadDisabled,
  files,
  onDeleteFile,
  iconOnlyButtons,
  activeFileId,
  preserveOrder,
  requireDeleteConfirmation
}) => {
  // preserveOrder lets the parent control the sort order (e.g. the downloads table sorts by
  // filename); otherwise fall back to newest-first by created_at.
  const sortedFiles = preserveOrder
    ? files
    : [...files].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
  return (
    <FileListWrapper>
      {sortedFiles.map((file) => (
        <FileItem
          disabled={disabled}
          viewOnly={viewOnly}
          onlyUploadDisabled={onlyUploadDisabled}
          key={file.id}
          file={file}
          onDelete={onDeleteFile}
          iconOnlyButtons={iconOnlyButtons}
          isActive={activeFileId === file.id}
          requireDeleteConfirmation={requireDeleteConfirmation}
        />
      ))}
    </FileListWrapper>
  );
};

export default FileList;
